import { createTheme } from '@mui/material/styles';

import { blue, blue_back, c_error_s, c_primary,c_primary_l, c_secondary, orange, orange_back } from "./utils/constants/ColorConst";

export const theme = createTheme({
    palette: {
      primary: {
        main: `${c_primary}`,
        light: `${c_primary_l}`,
      },
      secondary: {
        main: `${c_secondary}`
      },
      success: {
        main: `#096D2A`,
        light: `#EDFEF2`
      },
      error: {
        main: `${c_error_s}`
      },
      warning: {
        main: `${orange}`,
        light: `${orange_back}`
      },
      info:{
        main:`${blue_back}`,
        light:`${blue}`
      },
      purple:{
        main:`#c2a5cc`,
        light:`${c_primary_l}`
      }
    }
  })